"use client";
import Image from "next/image";
import Link from "next/link";
import HomeSliderImg from "@/public/images/homeslider.jpg";
import About from "@/public/images/home.jpg";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css/pagination";
import "swiper/css";

const HomeSlider = ({ item }) => {
  return (
    <div className="homeSlider">
      <div className="container">
        <Swiper
          modules={[Pagination]}
          spaceBetween={10}
          slidesPerView={1}
          pagination={{ clickable: true }}
          // onSlideChange={() => console.log("slide change")}
          // onSwiper={(swiper) => console.log(swiper)}
        >
          {item?.data?.map((itemId) => (
            <SwiperSlide key={itemId.id}>
              <div className="homeSliderCard">
                <Image
                  src={itemId.title_image.main}
                  alt={itemId.title}
                  width={1000}
                  height={1000}
                />
                <h2>{itemId.title}</h2>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default HomeSlider;
